<template>
  <v-container v-if="$auth.check()">
    <v-row>
      <v-col :cols="12">
        <h1>{{ $tc('texts.cooperationAgreement', 2) }}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :loading="fetchCooperationAgreementsPending"
              :items="formattedItems"
              must-sort
              :no-data-text="$t('texts.tableNoEntries')"
              :no-results-text="$t('texts.noSearchEntries')"
              :footer-props="{ itemsPerPageText: $t('texts.rowsPerPage')}"
              class="elevation-0"
              :hide-default-footer="formattedItems.length <= 5"
            >
              <template v-slot:item.status="{ item }">
                <v-tooltip right color="green" v-if="item.status !== 'CANCELLED'">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="green">lens</v-icon>
                  </template>
                  <span>{{ $t('texts.cooperationAgreementValid') }}</span>
                </v-tooltip>
                <v-tooltip right color="error" v-else>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" color="error">lens</v-icon>
                  </template>
                  <span>{{ $t('texts.cooperationAgreementInvalid') }}<br>{{ $t('texts.questionsToCompany') }}</span>
                </v-tooltip>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="item.status !== 'CANCELLED'"
                  icon class="mx-0"
                  @click="showPdfDialog({
                    title: $tc('texts.cooperationAgreement', 1),
                    pdfLink: `${item.url}`
                  })"
                >
                  <v-icon color="primary">insert_drive_file</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';

const { mapState: mapEmployeeState, mapActions: mapEmployeeActions } = createNamespacedHelpers('employee');

export default {
  name: 'EmployeeCooperationAgreements',
  created() {
    this.fetchCooperationAgreements();
  },
  computed: {
    ...mapEmployeeState([
      'fetchCooperationAgreementsPending',
      'cooperationAgreements',
    ]),
    headers() {
      const headers = [
        { text: this.$i18n.t('texts.status'), value: 'status', sortable: false },
        { text: this.$i18n.t('texts.date'), value: 'formattedCreatedAt', align: 'left' },
        { text: `${this.$i18n.t('texts.company.label')} 1`, value: 'job1_company', align: 'left' },
        { text: `${this.$i18n.t('texts.company.label')} 2`, value: 'job2_company', align: 'left' },
        { text: this.$i18n.t('texts.interruption'), value: 'formattedBreak', align: 'left' },
        {
          text: '', value: 'actions', sortable: false, align: 'right',
        },
      ];
      return headers;
    },
    formattedItems() {
      if (this.cooperationAgreements.length > 0) {
        return this.cooperationAgreements.map((item) => {
          const formattedCreatedAt = this.$options.filters.formatDateShort(item.created_at);
          const formattedJob1End = this.$options.filters.formatDateShort(item.job1_end);
          const formattedJob2Start = this.$options.filters.formatDateShort(item.job2_start);
          const breakInDays = this.calculateBreak(item.job1_end, item.job2_start);
          const formattedBreak = `${formattedJob1End} - ${formattedJob2Start} (${breakInDays} ${this.$i18n.tc('texts.day', breakInDays)})`;
          const formattedItem = {
            ...item,
            formattedCreatedAt,
            formattedBreak,
          };
          return formattedItem;
        });
      }
      return [];
    },
  },
  methods: {
    ...mapEmployeeActions([
      'fetchCooperationAgreements',
    ]),
    showPdfDialog(item) {
      this.$eventBus.$emit('show-pdf-dialog', item);
    },
    calculateBreak(endDate, startDate) {
      const date1 = moment(endDate);
      const date2 = moment(startDate);
      return date2.diff(date1, 'days') - 1;
    },
  },
};
</script>
